// Arabic strings for the assets area. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  '— Custodian:': '— أمين العهدة:',
  ', {n} skipped': '، وتم تخطي {n}',
  ', {n} will be skipped': '، وسيتم تخطي {n}',
  ', or pick one from the list below.': '، أو اختر أصلًا من القائمة أدناه.',
  '; {n} item(s) triggered replenishment.': '؛ أدى {n} صنف إلى طلب إعادة تزويد.',
  '. An automated loss log entry will be created in': '. سيتم إنشاء قيد فاقد تلقائي في',
  '. Each change is on the asset\'s timeline and in the audit trail.': '. كل تغيير مسجَّل في السجل الزمني للأصل وفي سجل التدقيق.',
  '. Issue, repair, transfer, disposal and write-off change the status through their own steps.': '. الصرف والإصلاح والنقل والاستبعاد والشطب تغيّر الحالة عبر خطواتها الخاصة.',
  '. Total loss': '. إجمالي الفاقد',
  '(optional, for temporary loans)': '(اختياري، للإعارات المؤقتة)',
  '(required: why is it out of service?)': '(إلزامي: لماذا هو خارج الخدمة؟)',
  '(required)': '(إلزامي)',
  '{item}: returned count cannot exceed {n} dispatched': '{item}: لا يمكن أن يتجاوز العدد المرتجع {n} مصروفة',
  '{items} item(s) flagged and {records} breakage record(s) logged ({loss}).': 'تم تمييز {items} صنف وتسجيل {records} سجل كسر ({loss}).',
  '{label} ready: the label sheet (50 x 25 mm) is open - print it to your label printer.': '{label} جاهزة: ورقة الملصقات (50 × 25 مم) مفتوحة - اطبعها على طابعة الملصقات.',
  '{n} asset': '{n} أصل',
  '{n} asset label(s)': '{n} ملصق أصل',
  '{n} asset match:': 'يطابق {n} أصل:',
  '{n} asset updated': 'تم تحديث {n} أصل',
  '{n} assets': '{n} أصول',
  '{n} Assets': '{n} أصل',
  '{n} assets match:': 'يطابق {n} أصول:',
  '{n} assets updated': 'تم تحديث {n} أصول',
  '{n} Day Overdue': 'متأخر {n} يوم',
  '{n} Days Overdue': 'متأخر {n} أيام',
  '{n} Event': '{n} مناسبة',
  '{n} event kit': '{n} مجموعة مناسبة',
  '{n} event kits': '{n} مجموعات مناسبات',
  '{n} Events': '{n} مناسبات',
  '{n} Kit': '{n} مجموعة',
  '{n} Kits': '{n} مجموعات',
  '{n} Labels': '{n} ملصق',
  '{n} Lines': '{n} سطر',
  '{n} locations': '{n} مواقع',
  '{n} on hand': '{n} متوفر',
  '{n} over-received': '{n} مستلم بالزيادة',
  '{n} overdue loan': '{n} إعارة متأخرة',
  '{n} overdue loans': '{n} إعارات متأخرة',
  '{n} sent': '{n} مُرسَل',
  '{n} Units': '{n} وحدة',
  '{qty} {item} damaged (Standard Cost: {cost} each)': '{qty} {item} تالف (التكلفة القياسية: {cost} للقطعة)',
  '{qty} {item} missing (Standard Cost: {cost} each)': '{qty} {item} مفقود (التكلفة القياسية: {cost} للقطعة)',
  '{received} of {specified} received across {locations} location(s) · {outstanding} outstanding · {placed} placed': 'تم استلام {received} من {specified} عبر {locations} موقع · {outstanding} متبقٍّ · {placed} تم وضعه',
  '{ref} approved. It is now in transit awaiting the receiving custodian\'s sign-off.': 'تم اعتماد {ref}. وهو الآن قيد النقل بانتظار توقيع أمين العهدة المستلم.',
  '{ref} dispatched - status is now {status}. Signed off by {name}.': 'تم صرف {ref} - الحالة الآن {status}. وقّعه {name}.',
  '{ref} return reconciled - status is now {status}.': 'تمت تسوية إرجاع {ref} - الحالة الآن {status}.',
  '{tag} escalated to Property Management.': 'تم تصعيد {tag} إلى إدارة العقار.',
  '{tag} received from {property}. It now belongs to this property.': 'تم استلام {tag} من {property}. وهو الآن تابع لهذا العقار.',
  '{tag} returned damaged. Exception {ref} raised and a repair record opened.': 'أُرجع {tag} تالفًا. تم رفع الاستثناء {ref} وفتح سجل إصلاح.',
  '{tag} returned damaged. Exception {ref} raised.': 'أُرجع {tag} تالفًا. تم رفع الاستثناء {ref}.',
  '{tag} returned in {condition} condition ({ref}).': 'أُرجع {tag} بحالة {condition} ({ref}).',
  '{valid} item(s) ready, {invalid} with errors, {matched} matched to your catalogue. Quantities are per location: {locations} location(s) of this type.': '{valid} صنف جاهز، و{invalid} بها أخطاء، و{matched} مطابق لكتالوجك. الكميات لكل موقع: {locations} موقع من هذا النوع.',
  '% loss tolerance': '% من حد الفاقد المسموح',
  '% recoverable VAT': '% ضريبة قيمة مضافة قابلة للاسترداد',
  '50 x 25 mm label': 'ملصق 50 × 25 مم',
  '50 x 25 mm label (PDF)': 'ملصق 50 × 25 مم (PDF)',
  'Above': 'أعلى من',
  'Above {pct}% loss tolerance': 'أعلى من حد الفاقد المسموح {pct}%',
  'Accept & Sign': 'قبول وتوقيع',
  'Accept and sign {ref}': 'قبول وتوقيع {ref}',
  'Accept and sign for this asset': 'اقبل هذا الأصل ووقّع على استلامه',
  'Accepting custodian': 'أمين العهدة المستلم',
  'Active Custody Register': 'سجل العهد النشطة',
  'Active Kits Dispatched': 'المجموعات المصروفة النشطة',
  'Alerts': 'التنبيهات',
  'All categories': 'جميع الفئات',
  'All conditions': 'جميع الحالات الفنية',
  'All events': 'جميع الأحداث',
  'All locations': 'جميع المواقع',
  'All statuses': 'جميع الحالات',
  'Already escalated': 'تم التصعيد مسبقًا',
  'Already in transit; accept the pending transfer first': 'قيد النقل بالفعل؛ اقبل التحويل المعلّق أولًا',
  'An item can only appear once per kit': 'لا يمكن أن يتكرر الصنف في المجموعة الواحدة',
  'Apply filter': 'تطبيق التصفية',
  'Approve {ref}': 'اعتماد {ref}',
  'Arriving from other properties': 'واردة من عقارات أخرى',
  'asset': 'أصل',
  'Asset': 'أصل',
  'Asset cost:': 'تكلفة الأصل:',
  'Asset Detail': 'تفاصيل الأصل',
  'Asset Item & Tag': 'الأصل والوسم',
  'Asset Item Name': 'اسم الأصل',
  'Asset item name is required': 'اسم الأصل مطلوب',
  'Asset label sheet': 'ورقة ملصقات الأصول',
  'Asset Label Sheet ({n})': 'ورقة ملصقات الأصول ({n})',
  'Asset list': 'قائمة الأصول',
  'Asset tag {code}': 'وسم الأصل {code}',
  'Asset Tag / Barcode': 'وسم الأصل / الباركود',
  'Asset Tag Label Preview': 'معاينة ملصق وسم الأصل',
  'At or above the AED {threshold} capitalisation threshold: capitalised.': 'عند حد الرسملة البالغ {threshold} درهم أو أعلى منه: تمت رسملته.',
  'Auto-generated per unit': 'يُنشأ تلقائيًا لكل وحدة',
  'Awaiting delivery': 'بانتظار التسليم',
  'Awaiting label print': 'بانتظار طباعة الملصق',
  'Awaiting receiving Dept sign-off': 'بانتظار توقيع القسم المستلم',
  'Ballroom / Venue': 'القاعة / المكان',
  'Banquets': 'الولائم',
  'Batch Checkout': 'صرف دفعة',
  'Below capitalisation threshold; excluded from depreciation': 'أقل من حد الرسملة؛ مستبعد من الإهلاك',
  'Below the AED {threshold} capitalisation threshold: expensed upon acquisition.': 'أقل من حد الرسملة البالغ {threshold} درهم: يُحمَّل كمصروف عند الاقتناء.',
  'Below the capitalisation threshold: expensed upon acquisition and excluded from depreciation.': 'أقل من حد الرسملة: يُحمَّل كمصروف عند الاقتناء ويُستبعد من الإهلاك.',
  'Bind it to an asset': 'اربطه بأصل',
  'Book': 'الدفتر',
  'Book value': 'القيمة الدفترية',
  'Bulk edit': 'تعديل جماعي',
  'Bulk edit the filtered assets': 'تعديل الأصول المصفّاة جماعيًا',
  'by': 'بواسطة',
  'Capitalised': 'مُرسمَل',
  'Category': 'الفئة',
  'change': 'تغيير',
  'Change': 'تغيير',
  'Change parent': 'تغيير الأصل الأب',
  'Change status': 'تغيير الحالة',
  'changes': 'تغييرات',
  'Check': 'تحقق',
  'Check file': 'فحص الملف',
  'Check out event kits in batches, track custody and reconcile returns after each function.': 'اصرف مجموعات المناسبات على دفعات، وتتبّع العهدة، وسوِّ المرتجعات بعد كل مناسبة.',
  'Checked Out': 'مصروفة',
  'Choose a condition': 'اختر حالة فنية',
  'Choose a condition grade': 'اختر درجة الحالة الفنية',
  'Choose a PDF or an image to upload': 'اختر ملف PDF أو صورة لرفعها',
  'Choose the new status': 'اختر الحالة الجديدة',
  'Completed This Month': 'المكتمل هذا الشهر',
  'Components': 'المكونات',
  'Condition': 'الحالة الفنية',
  'Condition for {item}': 'حالة {item}',
  'Condition on arrival': 'الحالة عند الوصول',
  'Condition recorded as {condition}.': 'تم تسجيل الحالة: {condition}.',
  'Condition:': 'الحالة الفنية:',
  'Confirm': 'تأكيد',
  'Confirm {n} change': 'تأكيد {n} تغيير',
  'Confirm {n} changes': 'تأكيد {n} تغييرات',
  'Confirm Dispatch': 'تأكيد الصرف',
  'Confirm receipt': 'تأكيد الاستلام',
  'Cost includes': 'تشمل التكلفة',
  'Cost includes {rate}% recoverable VAT': 'تشمل التكلفة ضريبة قيمة مضافة قابلة للاسترداد بنسبة {rate}%',
  'Create Event Kit': 'إنشاء مجموعة مناسبة',
  'Current Location': 'الموقع الحالي',
  'Current Quantity': 'الكمية الحالية',
  'Current:': 'الحالي:',
  'Custodian': 'أمين العهدة',
  'Custodian (Banquet Captain)': 'أمين العهدة (رئيس الولائم)',
  'Custodian & Dept': 'أمين العهدة والقسم',
  'Custodian Department': 'قسم أمين العهدة',
  'Custodian Dept': 'قسم أمين العهدة',
  'Custodian Digital Sign-Off (Banquet Captain full name)': 'التوقيع الرقمي لأمين العهدة (الاسم الكامل لرئيس الولائم)',
  'Custodian is required': 'أمين العهدة مطلوب',
  'Custodian sign-off is required': 'توقيع أمين العهدة مطلوب',
  'Custodian:': 'أمين العهدة:',
  'Custody accepted': 'تم قبول العهدة',
  'Custody Handover Acceptance': 'قبول تسليم العهدة',
  'Custody handover signed and completed! {tag} is now {status} at {location} under {department}.': 'تم توقيع تسليم العهدة وإكماله! {tag} الآن بحالة {status} في {location} لدى {department}.',
  'Custody Log': 'سجل العهدة',
  'Custody transfer dispatched! {ref} sent to {department} for digital acceptance (Department Head approval required for this high-value asset).': 'تم إرسال نقل العهدة! أُرسل {ref} إلى {department} للقبول الرقمي (يلزم اعتماد رئيس القسم لهذا الأصل عالي القيمة).',
  'Custody transfer dispatched! {ref} sent to {department} for digital acceptance.': 'تم إرسال نقل العهدة! أُرسل {ref} إلى {department} للقبول الرقمي.',
  'Custody Transfer Workflow': 'سير عمل نقل العهدة',
  'Damaged': 'تالف',
  'Damaged in Transit (Log Discrepancy)': 'تالف أثناء النقل (تسجيل فرق)',
  'Delivery Date': 'تاريخ التسليم',
  'Delivery date is required': 'تاريخ التسليم مطلوب',
  'Delivery note / PO': 'مذكرة التسليم / أمر الشراء',
  'Department': 'القسم',
  'Department Head approval': 'اعتماد رئيس القسم',
  'Departments': 'الأقسام',
  'Dept:': 'القسم:',
  'Destination & Receiving Dept': 'الوجهة والقسم المستلم',
  'Destination Location': 'موقع الوجهة',
  'Destination Property': 'العقار المستلم',
  'Digital Signature Acceptance': 'القبول بالتوقيع الرقمي',
  'Digital signatures archived': 'التوقيعات الرقمية المؤرشفة',
  'Discrepancy Discovered': 'تم اكتشاف فرق',
  'Dispatch': 'صرف',
  'Dispatch confirmed by': 'أكّد الإرسال',
  'Dispatch confirmed by sender': 'أكّد المُرسِل الإرسال',
  'Dispatch Transfer Request': 'إرسال طلب النقل',
  'Dispatched': 'تم الصرف',
  'Dispatched with sign-off by': 'صُرف بتوقيع',
  'Dispatching...': 'جارٍ الصرف...',
  'Dispatching…': 'جارٍ الإرسال…',
  'Disposed': 'مُستبعد',
  'Document added.': 'تمت إضافة المستند.',
  'Document removed.': 'تمت إزالة المستند.',
  'Documents': 'المستندات',
  'Documents and photos': 'المستندات والصور',
  'Download': 'تنزيل',
  'Download PDF': 'تنزيل PDF',
  'Draft': 'مسودة',
  'Due': 'الاستحقاق',
  'e.g. DYS-992019-X': 'مثال: DYS-992019-X',
  'e.g. Dyson': 'مثال: Dyson',
  'e.g. Dyson Supersonic Hair Dryer': 'مثال: Dyson Supersonic Hair Dryer',
  'e.g. HD07 Pro': 'مثال: HD07 Pro',
  'e.g. Luxury Hand Towel 16x30': 'مثال: منشفة يد فاخرة 16x30',
  'e.g. PO-2025-089': 'مثال: PO-2025-089',
  'e.g. Samsung Hospitality': 'مثال: Samsung Hospitality',
  'Edits': 'التعديلات',
  'Enter a purchase cost greater than zero': 'أدخل تكلفة شراء أكبر من صفر',
  'Enter a unit cost greater than zero': 'أدخل تكلفة وحدة أكبر من صفر',
  'Enter a valid returned count for {item}': 'أدخل عددًا مرتجعًا صحيحًا لـ {item}',
  'Enter the name of the person receiving the asset': 'أدخل اسم الشخص الذي يستلم الأصل',
  'Enter the sender confirming the dispatch': 'أدخل اسم المُرسِل الذي يؤكد الإرسال',
  'Escalate': 'تصعيد',
  'Escalate {tag}': 'تصعيد {tag}',
  'Escalated': 'مُصعَّد',
  'Event Date': 'تاريخ المناسبة',
  'Event date is required': 'تاريخ المناسبة مطلوب',
  'event kit': 'مجموعة مناسبة',
  'Event Kit': 'مجموعة المناسبة',
  'Event kit {ref} "{name}" created and held In Store.': 'تم إنشاء مجموعة المناسبة {ref} "{name}" وحفظها في المخزن.',
  'Event Kit Manifests': 'بيانات مجموعات المناسبات',
  'Event Kit Name': 'اسم مجموعة المناسبة',
  'Event kit name is required': 'اسم مجموعة المناسبة مطلوب',
  'Event Type': 'نوع المناسبة',
  'Event type is required': 'نوع المناسبة مطلوب',
  'Every asset that matches the current filter is included. Preview the changes first; nothing is saved until you confirm.': 'تشمل العملية كل أصل يطابق التصفية الحالية. عاين التغييرات أولًا؛ لن يُحفظ شيء حتى تؤكد.',
  'Every kit line needs an item and a quantity of at least 1': 'يحتاج كل سطر في المجموعة إلى صنف وكمية لا تقل عن 1',
  'Expected Return Date': 'تاريخ الإرجاع المتوقع',
  'Expensed': 'مُحمَّل كمصروف',
  'Export Log': 'تصدير السجل',
  'Exported {n} custody movement.': 'تم تصدير {n} حركة عهدة.',
  'Exported {n} custody movements.': 'تم تصدير {n} حركات عهدة.',
  'Fair': 'مقبول',
  'Fair / Minor Scratches': 'مقبول / خدوش طفيفة',
  'FF&E, IT & Mechanical': 'الأثاث والتجهيزات، التقنية، والمعدات الميكانيكية',
  'File (PDF, JPEG, PNG or WebP)': 'الملف (PDF أو JPEG أو PNG أو WebP)',
  'Filter by category': 'التصفية حسب الفئة',
  'Finalize Return & Log Discrepancies': 'إنهاء الإرجاع وتسجيل الفروقات',
  'Finalizing...': 'جارٍ الإنهاء...',
  'Find': 'بحث',
  'Fixed asset registered successfully! {n} asset tagged ({tags}) and added to the inward register under PO {po}. Net cost {cost} per unit, recoverable VAT {vat}.': 'تم تسجيل الأصل الثابت بنجاح! تم وسم {n} أصل ({tags}) وإضافته إلى سجل الاستلام تحت أمر الشراء {po}. صافي التكلفة {cost} للوحدة، وضريبة القيمة المضافة القابلة للاسترداد {vat}.',
  'Fixed asset registered successfully! {n} assets tagged ({tags}) and added to the inward register under PO {po}. Net cost {cost} per unit, recoverable VAT {vat}.': 'تم تسجيل الأصول الثابتة بنجاح! تم وسم {n} أصول ({tags}) وإضافتها إلى سجل الاستلام تحت أمر الشراء {po}. صافي التكلفة {cost} للوحدة، وضريبة القيمة المضافة القابلة للاسترداد {vat}.',
  'Fixed Assets ({n})': 'الأصول الثابتة ({n})',
  'Found in the wrong place': 'وُجد في غير مكانه',
  'Found where expected': 'وُجد في مكانه المتوقع',
  'Gala Banquet': 'مأدبة احتفالية',
  'Generated Asset Tag': 'وسم الأصل المُنشأ',
  'Good': 'جيد',
  'Good Condition (Matches Dispatch Notice)': 'حالة جيدة (مطابق لإشعار الإرسال)',
  'Grand Ballroom': 'القاعة الكبرى',
  'Grand Ballroom Gala 2026': 'حفل القاعة الكبرى 2026',
  'has been retired.': 'أُخرج من الخدمة نهائيًا.',
  'Held by': 'في عهدة',
  'Holding Custodian': 'أمين العهدة الحائز',
  'Holding Location': 'موقع الحيازة',
  'Import list': 'استيراد القائمة',
  'Import only the rows without errors': 'استيراد الصفوف الخالية من الأخطاء فقط',
  'Import specification': 'استيراد المواصفات',
  'In locations': 'في المواقع',
  'In repair': 'قيد الإصلاح',
  'In service': 'في الخدمة',
  'In store': 'في المخزن',
  'In Store': 'في المخزن',
  'In Store (Storeroom custody)': 'في المخزن (عهدة المستودع)',
  'In transit': 'قيد النقل',
  'In Transit': 'قيد النقل',
  'In-Transit Movements': 'الحركات قيد النقل',
  'Initial Status': 'الحالة الأولية',
  'Initiate Custody Transfer': 'بدء نقل عهدة',
  'Initiate Transfer': 'بدء النقل',
  'Inward Fixed Asset': 'استلام أصل ثابت',
  'Inward New Asset': 'استلام أصل جديد',
  'Inward Pooled Stock': 'استلام مخزون مجمّع',
  'Inwarded This Month': 'المستلم هذا الشهر',
  'is not bound to an asset yet.': 'غير مرتبط بأصل بعد.',
  'Issue to a person': 'صرف لشخص',
  'Issued': 'مصروف',
  'Item {n}': 'الصنف {n}',
  'Item Name': 'اسم الصنف',
  'Item Name & Model': 'اسم الصنف والطراز',
  'Item name is required': 'اسم الصنف مطلوب',
  'Item SKU & Description': 'رمز الصنف والوصف',
  'Item Specification': 'مواصفات الصنف',
  'Kit ID': 'رقم المجموعة',
  'Kit Manifest': 'بيان المجموعة',
  'Last': 'آخر',
  'Linen, Glassware, Towels': 'البياضات والأواني الزجاجية والمناشف',
  'Linked system': 'النظام المرتبط',
  'Loading assets...': 'جارٍ تحميل الأصول...',
  'Loading custody log…': 'جارٍ تحميل سجل العهدة…',
  'Loading custody transfers…': 'جارٍ تحميل تحويلات العهدة…',
  'Loading event kits...': 'جارٍ تحميل مجموعات المناسبات...',
  'Loading manifest...': 'جارٍ تحميل البيان...',
  'Loan closed': 'أُغلقت الإعارة',
  'Loans held past their scheduled return date': 'إعارات تجاوزت تاريخ الإرجاع المحدد',
  'Location': 'الموقع',
  'Location / Room': 'الموقع / الغرفة',
  'Location Type': 'نوع الموقع',
  'locations)': 'مواقع)',
  'Loss Justification / Reason Code:': 'مبرر الفاقد / رمز السبب:',
  'Manage departmental custody handovers, inter-room relocations, and digital transfer receipts': 'أدر تسليمات العهدة بين الأقسام، وعمليات النقل بين الغرف، وإيصالات النقل الرقمية',
  'Manufacturer / Brand': 'الشركة المصنّعة / العلامة التجارية',
  'Manufacturer & Serial #': 'الشركة المصنّعة والرقم التسلسلي',
  'Manufacturer Serial Number': 'الرقم التسلسلي للشركة المصنّعة',
  'Model Number / Spec': 'رقم الطراز / المواصفات',
  'Model:': 'الطراز:',
  'Month Discrepancy Rate': 'معدل الفروقات الشهري',
  'More than one asset matches. Choose one:': 'يطابق أكثر من أصل. اختر واحدًا:',
  'Move to': 'نقل إلى',
  'Move to location': 'نقل إلى موقع',
  'Moves': 'الحركات',
  'Net asset cost:': 'صافي تكلفة الأصل:',
  'New': 'جديد',
  'New category': 'الفئة الجديدة',
  'New condition': 'الحالة الفنية الجديدة',
  'New Event Kit': 'مجموعة مناسبة جديدة',
  'New status': 'الحالة الجديدة',
  'Newest first': 'الأحدث أولًا',
  'No asset open yet': 'لم يُفتح أي أصل بعد',
  'No assets': 'لا توجد أصول',
  'No assets are out on issue. Issue one with a return date or to a named person from the transfer form.': 'لا توجد أصول مصروفة حاليًا. اصرف أصلًا بتاريخ إرجاع أو لشخص محدد من نموذج النقل.',
  'No assets match this filter. Clear the filter, or register assets from Inwarding & Tagging or by stamping room kits.': 'لا توجد أصول تطابق هذه التصفية. امسح التصفية، أو سجّل أصولًا من الاستلام والوسم أو بختم مجموعات الغرف.',
  'No assets match your filters.': 'لا توجد أصول تطابق عوامل التصفية.',
  'No assets match your search.': 'لا توجد أصول تطابق بحثك.',
  'No Book yet': 'لا يوجد دفتر بعد',
  'No components. Open a component (for example a compressor) and set this asset as its parent.': 'لا توجد مكونات. افتح مكوّنًا (مثل الضاغط) واجعل هذا الأصل أصله الأب.',
  'No custodians yet': 'لا يوجد أمناء عهدة بعد',
  'No custody loans are overdue.': 'لا توجد إعارات عهدة متأخرة.',
  'No custody transfers match your filters.': 'لا توجد تحويلات عهدة تطابق عوامل التصفية.',
  'No discrepancies found.': 'لم يتم العثور على فروقات.',
  'No documents yet.': 'لا توجد مستندات بعد.',
  'No event kits found.': 'لم يتم العثور على مجموعات مناسبات.',
  'No events of this type yet.': 'لا توجد أحداث من هذا النوع بعد.',
  'No events scheduled': 'لا توجد مناسبات مجدولة',
  'No Location Types yet. Create Location Types (for example "Deluxe King") in the property registry first, then import the opening specification for each.': 'لا توجد أنواع مواقع بعد. أنشئ أنواع المواقع (مثل "Deluxe King") في سجل العقار أولًا، ثم استورد مواصفات الافتتاح لكل نوع.',
  'No named person (department custody)': 'بدون شخص محدد (عهدة القسم)',
  'No other asset of this property matches.': 'لا يطابق أي أصل آخر في هذا العقار.',
  'No overdue loans': 'لا توجد إعارات متأخرة',
  'No pooled stock registered yet.': 'لم يُسجَّل مخزون مجمّع بعد.',
  'No properties yet. Add the property under Locations & Hierarchy first, then import its opening specification here.': 'لا توجد عقارات بعد. أضف العقار من المواقع والتسلسل الهرمي أولًا، ثم استورد مواصفات الافتتاح هنا.',
  'No receipts yet': 'لا توجد استلامات بعد',
  'No specification yet': 'لا توجد مواصفات بعد',
  'No tag bound': 'لا يوجد وسم مرتبط',
  'No transfers': 'لا توجد تحويلات',
  'Not found': 'غير موجود',
  'Not part of another asset.': 'ليس جزءًا من أصل آخر.',
  'Note': 'ملاحظة',
  'Nothing awaiting review': 'لا شيء بانتظار المراجعة',
  'Nothing has been recorded for this asset yet. Moves, audits, repairs and condition changes will appear here.': 'لم يُسجَّل شيء لهذا الأصل بعد. ستظهر هنا الحركات وعمليات الجرد والإصلاحات وتغييرات الحالة.',
  'Nothing is in transit to this property.': 'لا شيء قيد النقل إلى هذا العقار.',
  'Nothing is out on issue': 'لا شيء مصروف حاليًا',
  'Nothing received yet. Use "Record receipt" on an item when a delivery arrives.': 'لم يُستلم شيء بعد. استخدم "تسجيل استلام" على الصنف عند وصول الشحنة.',
  'Now': 'الآن',
  'Number, name, serial': 'الرقم أو الاسم أو الرقم التسلسلي',
  'of': 'من',
  'Oldest first': 'الأقدم أولًا',
  'on hand)': 'متوفر)',
  'One record per asset: where it is, who holds it, its condition and book value, and everything that has happened to it.': 'سجل واحد لكل أصل: مكانه، ومن يحوزه، وحالته وقيمته الدفترية، وكل ما جرى له.',
  'Only a Property Manager, Department Head or Admin can escalate': 'لا يمكن التصعيد إلا لمدير العقار أو رئيس القسم أو المسؤول',
  'Only the receiving Department Head can sign': 'لا يوقّع إلا رئيس القسم المستلم',
  'Open the asset record and timeline': 'فتح سجل الأصل وسجله الزمني',
  'Opening inventory': 'مخزون الافتتاح',
  'Operational Status': 'الحالة التشغيلية',
  'or': 'أو',
  'or pick it': 'أو اختره',
  'Origin Location & Dept': 'موقع المصدر والقسم',
  'Originating Custodian Dept': 'قسم أمين العهدة المُرسِل',
  'Out of service': 'خارج الخدمة',
  'Outstanding': 'المتبقي',
  'Over-received': 'مستلم بالزيادة',
  'Overdue custody batch complete: {n} reminder sent to holding custodians.': 'اكتملت دفعة العهد المتأخرة: أُرسل {n} تذكير إلى أمناء العهدة الحائزين.',
  'Overdue custody batch complete: {n} reminders sent to holding custodians.': 'اكتملت دفعة العهد المتأخرة: أُرسلت {n} تذكيرات إلى أمناء العهدة الحائزين.',
  'Overdue custody batch complete: no new reminders were due today.': 'اكتملت دفعة العهد المتأخرة: لا توجد تذكيرات جديدة مستحقة اليوم.',
  'Overdue custody escalated': 'تم تصعيد العهدة المتأخرة',
  'Overdue Custody Report': 'تقرير العهد المتأخرة',
  'Overdue return reminder sent': 'أُرسل تذكير الإرجاع المتأخر',
  'Par Level': 'المستوى المعياري',
  'Par level must be at least 1': 'يجب ألا يقل المستوى المعياري عن 1',
  'Parent and components': 'الأصل الأب والمكونات',
  'Parent asset cleared.': 'تمت إزالة الأصل الأب.',
  'Parent asset set.': 'تم تعيين الأصل الأب.',
  'Part of': 'جزء من',
  'part of {tag}': 'جزء من {tag}',
  'Part received': 'مستلم جزئيًا',
  'Pending / In Transit': 'معلّق / قيد النقل',
  'Pending Acceptance': 'بانتظار القبول',
  'Pending Approval': 'بانتظار الاعتماد',
  'Pending Return Review': 'بانتظار مراجعة الإرجاع',
  'Pending Tag': 'بانتظار الوسم',
  'Pending Tag Print': 'بانتظار طباعة الوسم',
  'Per location': 'لكل موقع',
  'per unit, including {vat} non-recoverable VAT.': 'للوحدة، بما في ذلك {vat} ضريبة قيمة مضافة غير قابلة للاسترداد.',
  'per unit; recoverable VAT {vat}.': 'للوحدة؛ ضريبة القيمة المضافة القابلة للاسترداد {vat}.',
  'Photo (optional, JPEG, PNG or WebP)': 'صورة (اختياري، JPEG أو PNG أو WebP)',
  'Physical Inspection Condition': 'حالة الفحص الفعلي',
  'Placed': 'تم الوضع',
  'Placement Location (Storeroom)': 'موقع التخزين (المستودع)',
  'Please select one or more assets to print batch tags.': 'يرجى اختيار أصل واحد أو أكثر لطباعة وسوم الدفعة.',
  'PO #{po} Received': 'تم استلام أمر الشراء #{po}',
  'PO Number': 'رقم أمر الشراء',
  'PO number is required': 'رقم أمر الشراء مطلوب',
  'Pooled Bulk Inventory': 'المخزون المجمّع',
  'Pooled inventory stock received and updated in storeroom par ledger: {item} now {qty} {unit} in {location} (+{received}, total value {value}).': 'تم استلام المخزون المجمّع وتحديث سجل المستوى المعياري للمستودع: {item} أصبح {qty} {unit} في {location} (+{received}، القيمة الإجمالية {value}).',
  'Pooled SKUs': 'الأصناف المجمّعة',
  'Pooled Stock ({n})': 'المخزون المجمّع ({n})',
  'Pooled Stock Issue': 'صرف المخزون المجمّع',
  'Poor': 'سيئ',
  'Post-Event Return Reconciliation': 'تسوية الإرجاع بعد المناسبة',
  'Pre-opening': 'ما قبل الافتتاح',
  'Preview changes': 'معاينة التغييرات',
  'Print barcode tag': 'طباعة وسم الباركود',
  'Print Batch Tags': 'طباعة وسوم الدفعة',
  'Print Label': 'طباعة الملصق',
  'Print Tag': 'طباعة الوسم',
  'Print tag {tag}': 'طباعة الوسم {tag}',
  'Provide operational justification for relocation or repair transfer...': 'اذكر المبرر التشغيلي للنقل أو التحويل للإصلاح...',
  'Provide the reason for movement': 'اذكر سبب النقل',
  'Purchase Cost': 'تكلفة الشراء',
  'Purchase Cost per Unit (AED)': 'تكلفة شراء الوحدة (درهم)',
  'Purchase Date': 'تاريخ الشراء',
  'Quantity': 'الكمية',
  'Quantity (units)': 'الكمية (وحدات)',
  'Quantity {n}': 'الكمية {n}',
  'Quantity must be between 1 and 500': 'يجب أن تكون الكمية بين 1 و500',
  'Re-category': 'إعادة التصنيف',
  'Reason (optional)': 'السبب (اختياري)',
  'Reason for Movement / Handover Notes': 'سبب النقل / ملاحظات التسليم',
  'Receive': 'استلام',
  'Receive pre-opening furniture and supplies against the specification for each Location Type, then place them into the rooms.': 'استلم أثاث ولوازم ما قبل الافتتاح مقابل مواصفات كل نوع موقع، ثم ضعها في الغرف.',
  'Receive purchase shipments, register serialized capital assets and pooled items, and print barcode/QR tags': 'استلم شحنات المشتريات، وسجّل الأصول الرأسمالية المسلسلة والأصناف المجمّعة، واطبع وسوم الباركود/QR',
  'Receive Stock': 'استلام المخزون',
  'Received': 'مستلم',
  'Received & Signed': 'مستلم وموقّع',
  'Received against specification': 'المستلم مقابل المواصفات',
  'Received by': 'استلمه',
  'Received on': 'تاريخ الاستلام',
  'Received Qty': 'الكمية المستلمة',
  'Received quantity must be at least 1': 'يجب ألا تقل الكمية المستلمة عن 1',
  'Received this month': 'مستلم هذا الشهر',
  'Received vs specified': 'المستلم مقابل المحدد',
  'Receiving Custodian Dept': 'قسم أمين العهدة المستلم',
  'Receiving Department:': 'القسم المستلم:',
  'Receiving Staff Name': 'اسم الموظف المستلم',
  'Receiving staff name is required': 'اسم الموظف المستلم مطلوب',
  'Recent receipts': 'الاستلامات الأخيرة',
  'Reconciling': 'قيد التسوية',
  'Recondition': 'تغيير الحالة الفنية',
  'Record receipt': 'تسجيل استلام',
  'Registration': 'التسجيل',
  'Rejected': 'مرفوض',
  'Rejected:': 'مرفوض:',
  'Released by': 'أفرج عنه',
  'Relocating between floors': 'النقل بين الطوابق',
  'Reminders': 'التذكيرات',
  'Remove "{title}" from this asset?': 'إزالة "{title}" من هذا الأصل؟',
  'Remove {title}': 'إزالة {title}',
  'Remove line {n}': 'إزالة السطر {n}',
  'Repairs': 'الإصلاحات',
  'Replaced by {tag}': 'استُبدل بـ {tag}',
  'Replacement': 'الاستبدال',
  'Replacements': 'الاستبدالات',
  'Replaces {tag}': 'يحل محل {tag}',
  'Replenishment notification dispatched for {items}.': 'أُرسل إشعار إعادة التزويد لـ {items}.',
  'Reprint barcode tag': 'إعادة طباعة وسم الباركود',
  'Reprint Tag': 'إعادة طباعة الوسم',
  'Requires variance count': 'يتطلب عدّ الفروقات',
  'Retired': 'مُخرج من الخدمة',
  'Return an issued asset': 'إرجاع أصل مصروف',
  'Return by': 'الإرجاع بحلول',
  'Return date cannot be in the past': 'لا يمكن أن يكون تاريخ الإرجاع في الماضي',
  'Return due': 'موعد الإرجاع',
  'Return Due': 'موعد الإرجاع',
  'Returned': 'مُرجَع',
  'Returned Count': 'العدد المرتجع',
  'Returned count for {item}': 'العدد المرتجع لـ {item}',
  'Returns & Arrivals': 'المرتجعات والواردات',
  'Returns to': 'يعود إلى',
  'Save & Generate Tag': 'حفظ وإنشاء الوسم',
  'Save receipt': 'حفظ الاستلام',
  'Save specification': 'حفظ المواصفات',
  'Save status': 'حفظ الحالة',
  'Say why the asset is being retired': 'اذكر سبب إخراج الأصل من الخدمة نهائيًا',
  'Say why the asset is out of service': 'اذكر سبب خروج الأصل عن الخدمة',
  'Scan a label or type its code above to open the asset\'s record. You can also open an asset from': 'امسح ملصقًا أو اكتب رمزه أعلاه لفتح سجل الأصل. يمكنك أيضًا فتح أصل من',
  'Scan a label, or type a tag code, asset number or serial number': 'امسح ملصقًا، أو اكتب رمز الوسم أو رقم الأصل أو الرقم التسلسلي',
  'Scan a tag into the search': 'امسح وسمًا في خانة البحث',
  'Scan or type the tag': 'امسح الوسم أو اكتبه',
  'Scan the asset tag or pick the asset being returned': 'امسح وسم الأصل أو اختر الأصل المُرجَع',
  'Scheduled Today': 'المجدول اليوم',
  'Search event kits': 'البحث في مجموعات المناسبات',
  'Search kits, ballrooms, custodians...': 'ابحث في المجموعات والقاعات وأمناء العهدة...',
  'Search tag, model, serial...': 'ابحث بالوسم أو الطراز أو الرقم التسلسلي...',
  'Search tag, name, serial...': 'ابحث بالوسم أو الاسم أو الرقم التسلسلي...',
  'Search the parent asset': 'البحث عن الأصل الأب',
  'Search the parent by asset number or name': 'ابحث عن الأصل الأب برقم الأصل أو اسمه',
  'Search transfer, asset...': 'ابحث في التحويلات أو الأصول...',
  'Select {tag}': 'تحديد {tag}',
  'Select a destination location': 'اختر موقع الوجهة',
  'Select a kit held In Store...': 'اختر مجموعة محفوظة في المخزن...',
  'Select a location…': 'اختر موقعًا…',
  'Select a receiving department': 'اختر القسم المستلم',
  'Select a storeroom': 'اختر مستودعًا',
  'Select all assets': 'تحديد كل الأصول',
  'Select an asset to transfer': 'اختر أصلًا لنقله',
  'Select an asset…': 'اختر أصلًا…',
  'Select Asset to Transfer': 'اختر الأصل المراد نقله',
  'Select storeroom...': 'اختر المستودع...',
  'Select the event kit to dispatch': 'اختر مجموعة المناسبة المراد صرفها',
  'Select...': 'اختر...',
  'Send Overdue Reminders': 'إرسال تذكيرات التأخير',
  'sent': 'مُرسَل',
  'Sent by': 'أرسله',
  'Serial number': 'الرقم التسلسلي',
  'Serialized Fixed Assets': 'الأصول الثابتة المسلسلة',
  'Set condition': 'تحديد الحالة الفنية',
  'Set parent': 'تعيين الأصل الأب',
  'Show events of type': 'عرض الأحداث من النوع',
  'Showing': 'عرض',
  'Showing {count} of {total} assets': 'عرض {count} من {total} أصل',
  'Showing {from}–{to} of {total}': 'عرض {from}–{to} من {total}',
  'Showing assets and their current custodians': 'عرض الأصول وأمناء عهدتها الحاليين',
  'Showing recent custody transfers': 'عرض أحدث تحويلات العهدة',
  'Sign & Complete Handover': 'التوقيع وإكمال التسليم',
  'Signed by {name} on {date}; condition {condition}': 'وقّعه {name} في {date}؛ الحالة {condition}',
  'Signed digitally via authenticated session': 'موقّع رقميًا عبر جلسة موثّقة',
  'Signing…': 'جارٍ التوقيع…',
  'Skipped assets': 'الأصول المتخطاة',
  'SN:': 'الرقم التسلسلي:',
  'Specification CSV': 'ملف المواصفات CSV',
  'Specification file (CSV: item, qty per location, optional tracking and unit cost)': 'ملف المواصفات (CSV: الصنف، الكمية لكل موقع، ونمط التتبع وتكلفة الوحدة اختياريًا)',
  'Specification saved: {added} item(s) added, {updated} updated, {skipped} row(s) with errors skipped.': 'تم حفظ المواصفات: أُضيف {added} صنف، وحُدّث {updated}، وتم تخطي {skipped} صف به أخطاء.',
  'Specification saved: {added} item(s) added, {updated} updated.': 'تم حفظ المواصفات: أُضيف {added} صنف، وحُدّث {updated}.',
  'Specified': 'المحدد',
  'Stamp received items into locations': 'ختم الأصناف المستلمة في المواقع',
  'Stamped into {locations} location(s): {assets} tagged item(s) now wait for a tag, {pooled} pooled unit(s) added to stock.': 'تم الختم في {locations} موقع: {assets} صنف موسوم ينتظر الآن الوسم، وأُضيفت {pooled} وحدة مجمّعة إلى المخزون.',
  'Status': 'الحالة',
  'Status changed to {status}.': 'تم تغيير الحالة إلى {status}.',
  'Stock Status': 'حالة المخزون',
  'Storeroom': 'المستودع',
  'Supplier': 'المورّد',
  'Supplier (optional)': 'المورّد (اختياري)',
  'Supplier is required': 'المورّد مطلوب',
  'Tag': 'الوسم',
  'Tags Pending': 'وسوم معلّقة',
  'Target Par:': 'المستوى المعياري المستهدف:',
  'Template': 'القالب',
  'Text': 'نص',
  'The asset is in transit until someone at the receiving property confirms receipt. Its book value stays with this property.': 'يبقى الأصل قيد النقل حتى يؤكد أحد في العقار المستلم الاستلام. وتبقى قيمته الدفترية لدى هذا العقار.',
  'The file could not be read': 'تعذّرت قراءة الملف',
  'The file must be smaller than {mb} MB': 'يجب أن يكون حجم الملف أقل من {mb} ميغابايت',
  'The photo could not be read': 'تعذّرت قراءة الصورة',
  'This asset has {n} component. Move it with it when the move is signed for.': 'لهذا الأصل {n} مكوّن. انقله معه عند توقيع النقل.',
  'This asset has {n} component. Moving it can take them along (tick the option when you raise the custody move); disposing of it releases them.': 'لهذا الأصل {n} مكوّن. يمكن نقله معه (فعّل الخيار عند إنشاء نقل العهدة)؛ واستبعاد الأصل يحرّره.',
  'This asset has {n} components. Move them with it when the move is signed for.': 'لهذا الأصل {n} مكونات. انقلها معه عند توقيع النقل.',
  'This asset has {n} components. Moving it can take them along (tick the option when you raise the custody move); disposing of it releases them.': 'لهذا الأصل {n} مكونات. يمكن نقلها معه (فعّل الخيار عند إنشاء نقل العهدة)؛ واستبعاد الأصل يحرّرها.',
  'This asset is valued at {cost}, above the Book Policy threshold of {threshold}. Department Head approval is required.': 'قيمة هذا الأصل {cost}، وهي أعلى من حد سياسة الدفتر البالغ {threshold}. يلزم اعتماد رئيس القسم.',
  'This property': 'هذا العقار',
  'Timeline': 'السجل الزمني',
  'Title (optional)': 'العنوان (اختياري)',
  'To place': 'للوضع',
  'Total': 'الإجمالي',
  'Total Assets': 'إجمالي الأصول',
  'total items in service': 'إجمالي الأصناف في الخدمة',
  'Total Tracked Custodians': 'إجمالي أمناء العهدة المتتبَّعين',
  'Track FF&E and OS&E deliveries against the pre-opening specification of each location type, then place the received items into the rooms.': 'تتبّع شحنات الأثاث والتجهيزات ومستلزمات التشغيل مقابل مواصفات ما قبل الافتتاح لكل نوع موقع، ثم ضع الأصناف المستلمة في الغرف.',
  'Tracking': 'التتبع',
  'Transfer': 'تحويل',
  'Transfer {tag}': 'تحويل {tag}',
  'Transfer #': 'رقم التحويل',
  'Transfer Date': 'تاريخ التحويل',
  'Transfer initiated': 'بدأ التحويل',
  'Transfer Receipt': 'إيصال التحويل',
  'Transfer Reference:': 'مرجع التحويل:',
  'Transfer rejected': 'رُفض التحويل',
  'Transfers': 'تحويلات',
  'Type full name to sign': 'اكتب الاسم الكامل للتوقيع',
  'Unit Cost (AED)': 'تكلفة الوحدة (درهم)',
  'Unit of Measure': 'وحدة القياس',
  'Until {date}': 'حتى {date}',
  'Upload': 'رفع',
  'Upload the manual, warranty or purchase invoice below so it is one tap away when the asset needs service.': 'ارفع الدليل أو الضمان أو فاتورة الشراء أدناه لتكون على بُعد نقرة عندما يحتاج الأصل إلى صيانة.',
  'Use the next tag in sequence': 'استخدم الوسم التالي في التسلسل',
  'Variance': 'الفرق',
  'VAT cannot be reclaimed': 'لا يمكن استرداد ضريبة القيمة المضافة',
  'VAT cannot be reclaimed (add it to cost)': 'لا يمكن استرداد ضريبة القيمة المضافة (أضفها إلى التكلفة)',
  'View Audit Trail': 'عرض سجل التدقيق',
  'View Manifest Details': 'عرض تفاصيل البيان',
  'View photo': 'عرض الصورة',
  'View Receipt': 'عرض الإيصال',
  'View receipt {ref}': 'عرض إيصال {ref}',
  'View Signature Receipt': 'عرض إيصال التوقيع',
  'Warranty': 'الضمان',
  'Warranty Expiry': 'انتهاء الضمان',
  'Warranty expiry cannot be before the purchase date': 'لا يمكن أن يسبق انتهاء الضمان تاريخ الشراء',
  'will change': 'ستتغير',
  'Within': 'ضمن',
  'Within {pct}% loss tolerance': 'ضمن حد الفاقد المسموح {pct}%',
  'Written off': 'مشطوب',
  'You can view issued assets; returns are recorded by storekeepers, department heads and managers.': 'يمكنك عرض الأصول المصروفة؛ ويسجّل المرتجعات أمناء المخازن ورؤساء الأقسام والمديرون.',
  'You cannot see the locations of that property: {error}': 'لا يمكنك رؤية مواقع ذلك العقار: {error}',
};
